import Reflux from 'reflux';

import actions from '../actions';
import configurationStore from './configuration-store';

export default Reflux.createStore({
	init() {
		this.listenToMany(actions);
		this.listenTo(configurationStore, this.onConfigurationChange);
		this.state = {
			userSelection: {},
			configuration: {
				preselection: {}
			}
		};
	},

	onConfigurationChange(configuration) {
		this.state.configuration = {
			preselection: configuration.properties
		};
	},

	onLoadItemsCompleted() {
		actions.loadItemsDone();
	},

	onInitializeMounting(initialState) {
		const initialSelection = Object.assign({}, this.state.configuration.preselection, initialState || {});
		actions.selectProperties(initialSelection);
	},

	onSelectProperties(properties) {
		this.output();
		actions.loadFacets();
		//actions.loadAccessoryIdsForItems();
		actions.loadItems();
	},

	onSelectProperty(facet, property) {
		if (property.countUnselected === 0 && !facet.isPreselecting) {
			return;
		}

		// get current state
		const currentPropertyId = this.state.userSelection[facet.id];
		const newPropertyId = currentPropertyId !== property.id ? property.id : null;

		if (newPropertyId === null && !property.isDeselectable) {
			return;
		}

		this.output();

		actions.loadFacets();
		//actions.loadItemCount({autoSheet: true});
		//actions.loadAccessoryIdsForItems();
		actions.loadItems();
	},

	getState() {
		return this.state;
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
});
